const i = {
  ":focus-visible": (s) => ({
    ...s.outline({ color: "primary", radius: "xxxl" })
  })
}, e = {
  md: {
    ...i,
    width: 10,
    height: 5,
    borderRadius: "md",
    ":focus-visible::after": {
      borderRadius: "lg"
    }
  },
  lg: {
    ...i,
    width: 13,
    height: 7,
    borderRadius: "lg",
    ":focus-visible::after": {
      borderRadius: "xl"
    }
  }
}, o = {
  switchSizes: e
};
export {
  i as focusVisible,
  o as switchesTheme
};
